// NotFound Page Styles - Mediatropy Theme
.not-found-container {
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, #f6f7f7 0%, #eceff0 100%);
    position: relative;
    overflow: hidden;
    padding: 20px;

    .not-found-wrapper {
        text-align: center;
        max-width: 800px;
        width: 100%;
        position: relative;
        z-index: 10;
        animation: fadeInUp 0.6s ease-out;
    }

    // Animated 404 Section
    .error-code-section {
        margin-bottom: 40px;

        .error-code {
            display: flex;
            align-items: center;
            justify-content: center;
            font-family: 'Avenir';
            font-weight: 800;
            font-size: 120px;
            line-height: 1;
            color: #1b1b1b;
            margin-bottom: 20px;
            position: relative;

            @media (max-width: 768px) {
                font-size: 80px;
            }

            .four {
                animation: slideIn 0.5s ease-out;
                text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);

                &.first {
                    animation-delay: 0.1s;
                }

                &.last {
                    animation-delay: 0.3s;
                }
            }

            .zero {
                width: 120px;
                height: 120px;
                margin: 0 10px;
                position: relative;
                animation: bounceIn 0.6s ease-out;
                animation-delay: 0.2s;

                @media (max-width: 768px) {
                    width: 80px;
                    height: 80px;
                }

                .mt-logo-circle {
                    width: 100%;
                    height: 100%;
                    background: #fed230;
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    box-shadow: 0 8px 24px rgba(254, 210, 48, 0.3);
                    animation: pulse 2s infinite;
                    cursor: pointer;
                    transition: transform 0.3s ease;

                    &:hover {
                        transform: scale(1.1) rotate(10deg);
                    }

                    .mt-logo {
                        font-family: 'Avenir';
                        font-weight: 800;
                        font-size: 40px;
                        color: #1b1b1b;
                        letter-spacing: -2px;

                        @media (max-width: 768px) {
                            font-size: 28px;
                        }
                    }
                }
            }
        }

        .error-subtitle {
            font-family: 'Avenir';
            font-size: 24px;
            font-weight: 500;
            color: #707070;
            text-transform: uppercase;
            letter-spacing: 3px;
            animation: fadeIn 0.8s ease-out;
            animation-delay: 0.4s;
            animation-fill-mode: backwards;

            @media (max-width: 768px) {
                font-size: 18px;
                letter-spacing: 2px;
            }
        }
    }

    // Message Section
    .message-section {
        margin-bottom: 40px;
        animation: fadeIn 0.8s ease-out;
        animation-delay: 0.5s;
        animation-fill-mode: backwards;

        .main-message {
            font-family: 'Avenir';
            font-size: 32px;
            font-weight: 800;
            color: #1b1b1b;
            margin-bottom: 16px;
            line-height: 1.2;

            @media (max-width: 768px) {
                font-size: 24px;
            }
        }

        .sub-message {
            font-family: 'Avenir';
            font-size: 16px;
            font-weight: 400;
            color: #707070;
            line-height: 1.6;

            @media (max-width: 768px) {
                font-size: 14px;
            }
        }
    }

    // Action Buttons
    .action-buttons {
        display: flex;
        gap: 16px;
        justify-content: center;
        margin-bottom: 60px;
        flex-wrap: wrap;
        animation: fadeIn 0.8s ease-out;
        animation-delay: 0.6s;
        animation-fill-mode: backwards;

        .ant-btn {
            min-width: 160px;
            height: 48px;
            font-size: 16px;
            font-weight: 600;
            border-radius: 24px;
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
            transition: all 0.3s ease;

            &:hover {
                transform: translateY(-2px);
                box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12);
            }

            // Primary button (yellow)
            &.btn-primary {
                background: #fed230;
                color: #1b1b1b;
                border: none;

                &:hover {
                    background: #1b1b1b;
                    color: #fed230;
                }
            }

            // Secondary button (green)
            &.btn-secondary {
                background: #b3d741;
                color: #1b1b1b;
                border: none;

                &:hover {
                    background: #1b1b1b;
                    color: #b3d741;
                }
            }
        }
    }

    // Quick Links Section
    .quick-links-section {
        margin-bottom: 40px;
        animation: fadeIn 0.8s ease-out;
        animation-delay: 0.7s;
        animation-fill-mode: backwards;

        .quick-links-title {
            font-family: 'Avenir';
            font-size: 18px;
            font-weight: 600;
            color: #4a4a4a;
            margin-bottom: 24px;
            text-transform: uppercase;
            letter-spacing: 1px;
        }

        .quick-links {
            display: flex;
            gap: 20px;
            justify-content: center;
            flex-wrap: wrap;

            .quick-link-card {
                background: #fff;
                border-radius: 12px;
                padding: 20px 30px;
                min-width: 140px;
                cursor: pointer;
                transition: all 0.3s ease;
                box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
                border: 1px solid transparent;

                &:hover {
                    transform: translateY(-3px);
                    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
                    border-color: #fed230;
                    background: rgba(254, 210, 48, 0.05);

                    .link-icon {
                        color: #fed230;
                        transform: scale(1.1);
                    }
                }

                .link-icon {
                    font-size: 24px;
                    color: #4a4a4a;
                    margin-bottom: 8px;
                    transition: all 0.3s ease;
                }

                .link-text {
                    font-family: 'Avenir';
                    font-size: 14px;
                    font-weight: 500;
                    color: #4a4a4a;
                }
            }
        }
    }

    // Fun Facts
    .fun-facts {
        background: rgba(254, 210, 48, 0.1);
        border-radius: 12px;
        padding: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 12px;
        max-width: 500px;
        margin: 0 auto;
        animation: fadeIn 0.8s ease-out;
        animation-delay: 0.8s;
        animation-fill-mode: backwards;

        .fun-fact-icon {
            font-size: 24px;
        }

        .fun-fact-text {
            font-family: 'Avenir';
            font-size: 14px;
            color: #4a4a4a;
            margin: 0;
            line-height: 1.4;
        }
    }

    // Background Decorations
    .background-decorations {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        pointer-events: none;
        z-index: 1;

        .decoration-circle {
            position: absolute;
            border-radius: 50%;
            opacity: 0.1;

            &.decoration-1 {
                width: 300px;
                height: 300px;
                background: #fed230;
                top: -100px;
                left: -100px;
                animation: float 6s ease-in-out infinite;
            }

            &.decoration-2 {
                width: 200px;
                height: 200px;
                background: #b3d741;
                bottom: -50px;
                right: -50px;
                animation: float 8s ease-in-out infinite;
                animation-delay: 1s;
            }

            &.decoration-3 {
                width: 150px;
                height: 150px;
                background: #fec578;
                top: 50%;
                left: 10%;
                animation: float 7s ease-in-out infinite;
                animation-delay: 2s;
            }
        }

        .decoration-dots {
            position: absolute;
            top: 20%;
            right: 15%;
            display: flex;
            gap: 8px;

            span {
                width: 8px;
                height: 8px;
                background: #fed230;
                border-radius: 50%;
                opacity: 0.3;
                animation: blink 2s ease-in-out infinite;

                @for $i from 1 through 5 {
                    &:nth-child(#{$i}) {
                        animation-delay: #{$i * 0.2}s;
                    }
                }
            }
        }
    }
}

// Animations
@keyframes fadeInUp {
    from {
        opacity: 0;
        transform: translateY(30px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@keyframes fadeIn {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}

@keyframes slideIn {
    from {
        opacity: 0;
        transform: translateX(-30px);
    }
    to {
        opacity: 1;
        transform: translateX(0);
    }
}

@keyframes bounceIn {
    0% {
        opacity: 0;
        transform: scale(0.3);
    }
    50% {
        transform: scale(1.05);
    }
    70% {
        transform: scale(0.95);
    }
    100% {
        opacity: 1;
        transform: scale(1);
    }
}

@keyframes pulse {
    0%, 100% {
        transform: scale(1);
    }
    50% {
        transform: scale(1.05);
    }
}

@keyframes float {
    0%, 100% {
        transform: translateY(0) translateX(0) rotate(0deg);
    }
    33% {
        transform: translateY(-20px) translateX(10px) rotate(5deg);
    }
    66% {
        transform: translateY(10px) translateX(-10px) rotate(-5deg);
    }
}

@keyframes blink {
    0%, 100% {
        opacity: 0.3;
    }
    50% {
        opacity: 0.8;
    }
}

// Responsive Design
@media (max-width: 480px) {
    .not-found-container {
        .action-buttons {
            .ant-btn {
                width: 100%;
                min-width: auto;
            }
        }

        .quick-links-section {
            .quick-links {
                .quick-link-card {
                    min-width: 100px;
                    padding: 15px 20px;
                }
            }
        }
    }
}